import * as THREE from "three";
import * as marietta from '../../../marietta';

/* CanvasInfo
 * 3Dビュークラス作成用の画面情報.
 */

export class CanvasInfo {

    private _screenSize: THREE.Vector2;

    private static _instance: CanvasInfo;

    static get(): CanvasInfo {
        if (CanvasInfo._instance === undefined) {
            new CanvasInfo();
        }
        return CanvasInfo._instance;
    }

    constructor() {
        CanvasInfo._instance = this;
        this._screenSize = new THREE.Vector2(0.0, 0.0);
    }

    public get size(): THREE.Vector2 {
        this.upate();
        return this._screenSize;
    }

    private upate() {
        const element = document.getElementById('webcad3dView');
        // const rect = element.getBoundingClientRect();
        // console.log(rect);
        const width = Math.round(document.body.clientWidth - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH);
        const height = Math.round(window.innerHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight);
        let renderableHeight = height;
        let renderableWidth = width;
        if (width > height) {
        renderableWidth = width;
        renderableHeight = Math.round(renderableWidth * (9 / 16));
        if(renderableHeight < height) {
            renderableHeight = height;
            renderableWidth = Math.round(renderableHeight * (16 / 9));
        }
        } else if (width < height) {
        renderableHeight = height;
        renderableWidth = Math.round(renderableHeight * (16 / 9));
        if (width > renderableWidth) {
            renderableWidth = width;
            renderableHeight = Math.round(renderableWidth * (9 / 16));
        }
        }
        const x = Math.abs((width-renderableWidth));
        const y = Math.abs( (height-renderableHeight));
        this._screenSize.set(renderableWidth, renderableHeight);
    }
}
